import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PenRulerRegular from './pen-ruler-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PenRulerRegular {...validProps} />;
}

SvgComponent.iconName = 'penRulerRegular';

export const PenRulerRegularIcon = svgIconWrapper(SvgComponent);
